import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const Logo = () => (
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',height:'100%',display:'block'}}>
    <defs>
      <linearGradient id="lg-auth" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F0CC6E"/>
        <stop offset="50%" stopColor="#C9973A"/>
        <stop offset="100%" stopColor="#8B6020"/>
      </linearGradient>
    </defs>
    <circle cx="60" cy="60" r="58" fill="#0a0a12" stroke="url(#lg-auth)" strokeWidth="1.5"/>
    <ellipse cx="60" cy="72" rx="28" ry="22" fill="none" stroke="url(#lg-auth)" strokeWidth="1.8"/>
    <circle cx="60" cy="38" r="14" fill="none" stroke="url(#lg-auth)" strokeWidth="1.8"/>
    <circle cx="60" cy="34" r="4" fill="#C9973A"/>
    <path d="M46 60 Q38 55 36 68 Q34 80 60 85 Q86 80 84 68 Q82 55 74 60" fill="none" stroke="url(#lg-auth)" strokeWidth="1.8"/>
    <line x1="48" y1="72" x2="72" y2="72" stroke="url(#lg-auth)" strokeWidth="1.2"/>
    <line x1="50" y1="77" x2="70" y2="77" stroke="url(#lg-auth)" strokeWidth="1"/>
    <path d="M30 55 L20 45 L38 50" fill="none" stroke="#E2B84A" strokeWidth="1.5"/>
    <path d="M90 55 L100 45 L82 50" fill="none" stroke="#E2B84A" strokeWidth="1.5"/>
    <circle cx="60" cy="90" r="8" fill="none" stroke="url(#lg-auth)" strokeWidth="1.5"/>
    <text x="60" y="94" textAnchor="middle" fill="#C9973A" fontSize="9" fontWeight="bold">₿</text>
    <text x="22" y="42" textAnchor="middle" fill="#C9973A" fontSize="8" fontWeight="bold">₿</text>
    <text x="98" y="42" textAnchor="middle" fill="#C9973A" fontSize="7" fontWeight="bold">Ξ</text>
  </svg>
);

export default function AuthPage({ onBack }) {
  const { signIn, signUp } = useAuth();
  const [mode, setMode] = useState('signin');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setSuccess('');
    setLoading(true);
    try {
      if (mode === 'signin') {
        await signIn(email, password);
      } else {
        if (!fullName.trim()) throw new Error('Full name is required.');
        if (password.length < 8) throw new Error('Password must be at least 8 characters.');
        await signUp(email, password, fullName);
        setSuccess('Account created! You can now sign in.');
        setMode('signin');
      }
    } catch (err) {
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-layout">
      <div className="auth-left">
        <div className="auth-left-logo">
          <div style={{width:40,height:40,overflow:'hidden',flexShrink:0}}><Logo /></div>
          <span className="auth-left-brand">Trading Buddha</span>
        </div>
        <h2>Your private<br /><em>trading edge</em></h2>
        <p>
          An institutional-grade XAUUSD framework for disciplined traders.
          Private journal. AI coach. Proven framework. Cancel anytime.
        </p>
        <ul className="auth-features">
          {[
            'AI Trading Coach',
            'Private trade journal — your data only',
            'Full 5-condition entry framework',
            'Interactive position size calculator',
            '12-point pre-trade checklist',
            'Just ₹999/month — cancel anytime',
          ].map(f => (
            <li key={f} className="auth-feature">
              <span className="auth-feature-dot"></span>
              {f}
            </li>
          ))}
        </ul>
      </div>

      <div className="auth-right">
        <button className="auth-back" onClick={onBack}>← Back to home</button>

        <div className="auth-toggle">
          <button
            className={`auth-toggle-btn ${mode === 'signin' ? 'active' : ''}`}
            onClick={() => { setMode('signin'); setError(''); setSuccess(''); }}
          >Sign In</button>
          <button
            className={`auth-toggle-btn ${mode === 'signup' ? 'active' : ''}`}
            onClick={() => { setMode('signup'); setError(''); setSuccess(''); }}
          >Create Account</button>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}
          {success && <div className="auth-success">{success}</div>}

          {mode === 'signup' && (
            <div className="auth-form-field">
              <label>FULL NAME</label>
              <input
                type="text"
                placeholder="Your full name"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                required
              />
            </div>
          )}

          <div className="auth-form-field">
            <label>EMAIL ADDRESS</label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="auth-form-field">
            <label>PASSWORD</label>
            <input
              type="password"
              placeholder={mode === 'signup' ? 'Minimum 8 characters' : 'Your password'}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-gold" disabled={loading} style={{width:'100%', justifyContent:'center', fontSize:17}}>
            {loading ? 'Please wait...' : mode === 'signin' ? 'Sign In' : 'Create Account'}
          </button>

          {mode === 'signin' && (
            <p style={{fontSize:13, color:'var(--text-3)', textAlign:'center', marginTop:8}}>
              Don't have an account?{' '}
              <button type="button" onClick={() => setMode('signup')} style={{background:'none',border:'none',color:'var(--gold-2)',cursor:'pointer',fontSize:13}}>
                Create one
              </button>
            </p>
          )}

          {mode === 'signup' && (
            <p style={{fontSize:12, color:'var(--text-4)', textAlign:'center', marginTop:4}}>
              After signup, you can subscribe inside the dashboard.
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
